const major = 1;
const minor = 9;
const patch = 3;

module.exports = `${major}.${minor}.${patch}`;
